<template>
  <div v-if="tips" class="holiday-tips os-font-14-500">
    <p>{{ tips }}</p>
  </div>
</template>

<script>
import API from '@/api'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'holidayTips',
  data() {
    return {
      tips: ''
    }
  },
  computed: {
    ...mapState('repair', ['repairType']),
    holidayType() {
      // 接口请求参数 0:预约 1:寄修,同城快修 2:上门维修
      switch (String(this.repairType)) {
        case '1':
          return '0'
        case '2':
          return '1'
        case '3':
          return '2'
        case '6':
          return '1'
        default:
          return ''
      }
    }
  },
  created() {
    this.setHolidayData()
  },
  mounted() {},
  methods: {
    ...mapMutations('repair', ['SET_HOLIDAY_IS_VALID']),
    setHolidayData() {
      API.getCommonHoliday({
        type: this.holidayType
      })
        .then(res => {
          if (res.code === 0 && res.data) {
            // 存储全局变量
            this.tips = res.data.content
            this.SET_HOLIDAY_IS_VALID(res.data.isValid || false)
          } else {
            console.log(res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.holiday-tips {
  padding: 16px;
  background-color: #fff;
  color: #415fff;
  margin: -28px 16px 40px 16px;
  position: relative;
  border-radius: 12px;
  display: flex;
  align-items: center;
  max-width: 664px;
  box-sizing: border-box;

  .vivo-dark-mode & {
    background-color: #1e1e1e;
  }

  @media screen and (min-width: 697px) {
    margin-left: auto;
    margin-right: auto;
  }

  &:before {
    content: '';
    width: 20px;
    height: 20px;
    background-image: url('~@/assets/img/introduction/wap/icon1.png');
    background-size: 100% 100%;
    margin-right: 10px;
    flex-shrink: 0;
  }

  p {
    max-width: calc(100% - 30px);
    flex-shrink: 0;
  }
}
</style>
